import React from "react";
import { ArrowUpRight, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

function MobileMenu({ menuOpen, setMenuOpen, setReserveOpen, scrollTo }) {
  return (
    <AnimatePresence>
      {menuOpen && (
        <motion.div
          className="mobile-menu"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <button className="menu-close" onClick={() => setMenuOpen(false)}>
            <X />
          </button>
          <div className="mobile-menu-inner">
            {["story", "menu", "experience", "events", "contact"].map((item, i) => (
              <motion.button
                key={item}
                onClick={() => scrollTo(item)}
                initial={{ y: 30, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: i * 0.08 }}
              >
                <span>0{i + 1}</span>
                {item}
              </motion.button>
            ))}
            <button
              className="mobile-reserve"
              onClick={() => {
                setMenuOpen(false);
                setReserveOpen(true);
              }}
            >
              Reserve a table <ArrowUpRight size={20} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default MobileMenu;
